import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as CustomFunction from '../../../../common/custom';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { toast } from 'react-toastify';
import {
  FieldTypes,
  systemAndRefField,
  childDataField,
  OptionTypeFields,
  textNumberField,
} from 'drapcode-constant';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { snakeCaseToTitleCase } from '../../../../common/utils/api_utils';
import CustomSelect from '../../../home/collections/CustomSelect';
import { drapcodeIcon } from '../../../../common/custom/icon-library';
import { customFunctionSchema } from '../../../../common/custom/function-validation';
import {
  lableForDatePatters,
  lableForUnixType,
  labelForDateDifference,
} from '../../../../common/custom/date-data';
import {
  lableForNumberPatters,
  labelForCurrency,
  labelForCurrencyPosition,
  labelForCurrencyDisplay,
  labelForCurrencyPattern,
  labelForCurrencymaxFraction,
  labelForPercentagePatterns,
} from '../../../../common/custom/math-data';
import {
  labelForFunctionMethod,
  parseUtilityFunctionFormData,
} from '../../../../common/utils/api_utils';
import CustomLoader from '../../../common/CustomLoader';
import { moveDefaultCollectionFieldsToEndAndSort } from '../../../../common/utils/api_utils';
import { iconForField } from '../../../../common/custom/icon-library';
import { extractRefField } from '../../../../common/utils/field-options';
import RestAPICollectionFieldsModal from '../../../external-api/rest-api/RestAPICollectionFieldsModal';
import { labelForSeparator } from '../../../../common/custom/string-data';
import * as Yup from 'yup';
import { prepareValidationForDerivedField } from '../../../data-connector/common/common_utils';
import { FieldsMapping } from './TableFormat/FieldsMapping';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
import ToggleButton from '../../../../common/ui/ToggleButton';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/theme-tomorrow';
import 'ace-builds/src-noconflict/mode-javascript';
export default class DataForm extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
    collection: PropTypes.object.isRequired,
    collections: PropTypes.array.isRequired,
  };

  state = {
    methodTypes: Object.keys(CustomFunction)
      .filter((key) => key !== 'data')
      .map((key) => ({
        value: key,
        label: labelForFunctionMethod(key),
      }))
      .sort(),
    methodType: null,
    formSchema: customFunctionSchema,
    toggleShowFieldsModal: false,
    addFieldsModal: false,
    copied: false,
    refCollection: null,
    tableRefernceFields: [{ id: 0, key: '', value: '' }],
    tableStyleToggle: false,
    editor: null,
  };

  toggleAddFieldsModal = () => this.setState({ addFieldsModal: !this.state.addFieldsModal });

  handleChangeForCount = (name, value) => {
    if (
      name[0] === 'subject' &&
      value &&
      ['COUNT', 'FIND_RECORD', 'PERCENTAGE', 'TABLE_FORMAT'].includes(this.state.methodType.value)
    ) {
      const {
        collections,
        collection: { fields },
      } = this.props;
      const field = fields.find((field) => field.fieldName === value.value);
      value.type = field.type;
      if (field.type !== FieldTypes.static_option.id) {
        const refCollectionName = field.refCollection.collectionName;
        const refCollection = collections.find(
          (collection) => collection.collectionName === refCollectionName,
        );
        this.setState({ refCollection });
      } else {
        this.setState({ refCollection: null, refField: null });
      }
    }
    if (name[0] === 'refField' && value) {
      const { projectId, actions, version } = this.props;
      const refCollectionField = this.state.refCollection.fields.find(
        (field) => field.fieldName === value.value,
      );
      if (childDataField.includes(refCollectionField.type)) {
        actions.loadCollectionItems({
          projectId,
          collectionName: refCollectionField.refCollection.collectionName,
          version,
        });
      }
    }
    return value;
  };

  handleChange = (name, value) => {
    value = this.handleChangeForCount(name, value);
    this.setState({ [name]: value });
  };

  getAllAllowedFieldForSelect = (dataTypes, collection) => {
    const { collections, projectDetail } = this.props;
    const { fields } = collection;
    const userCollection =
      collections &&
      collections.find((collection) => {
        return collection.collectionName === 'user';
      });
    if (fields.length > 0) {
      const collectionFields = moveDefaultCollectionFieldsToEndAndSort(
        fields.filter((field) => {
          if (dataTypes.length === 0) return true;
          if (field.fieldName !== 'createdBy' && dataTypes.includes(field.type)) return true;
        }),
      ).map((field) => ({
        value: field.fieldName,
        label: field.fieldTitle.en,
      }));
      if (['COUNT', 'FIND_RECORD', 'PERCENTAGE'].includes(this.state.methodType.value)) {
        return [{ label: 'Collection Field', options: [...collectionFields] }];
      } else {
        const referenceField = extractRefField(fields, collections, dataTypes, false).map(
          (field) => ({
            value: `RF::${field.fieldName}`,
            label: field.fieldTitle,
          }),
        );
        const isUserCollectionExist = !!(userCollection && Object.keys(userCollection).length);
        const currentUserFields = isUserCollectionExist
          ? userCollection.fields
              .filter((field) => dataTypes.includes(field.type))
              .map((field) => ({
                value: `current_user.${field.fieldName}`,
                label: field.fieldTitle.en,
              }))
          : [];
        const currentUserReferenceField = isUserCollectionExist
          ? extractRefField(userCollection.fields, collections, dataTypes, false).map((field) => ({
              value: `current_user_reference_field.${field.fieldName}`,
              label: field.fieldTitle,
            }))
          : [];

        const environmentVariable = projectDetail.environments[0].constants.map((constant) => ({
          value: `environment_variable.${constant.name}`,
          label: constant.name,
        }));
        return [
          { label: 'Collection Field', options: [...collectionFields] },
          { label: 'Reference Field', options: [...referenceField] },
          { label: 'Current LoggedIn User Field', options: [...currentUserFields] },
          {
            label: 'Current LoggedIn User Reference Field',
            options: [...currentUserReferenceField],
          },
          { label: 'Environment Variable', options: [...environmentVariable] },
        ];
      }
    } else {
      return [];
    }
  };

  descriptionToFormatTypes = (functionData, params, currency, displayType) => {
    const { methodType } = this.state;
    const currencyDisplay = currency[displayType]
      ? currency[displayType]
      : currency
      ? currency['symbol']
      : '$';
    if (methodType) {
      if (['FORMAT_DATE', 'DATE_ADD'].includes(functionData.name)) {
        return params.options.map((option) => ({
          value: option,
          label: lableForDatePatters(option),
        }));
      }
      if (['AVERAGE', 'ADDITION', 'MULTIPLY', 'SUBSTRACTION'].includes(functionData.name)) {
        return params.options.map((option) => ({
          value: option,
          label: lableForNumberPatters(option),
        }));
      }
      if (functionData.name === 'CURRENCY_FORMAT') {
        return params.options.map((option) => ({
          value: option,
          label: labelForCurrencyPattern(option, currencyDisplay),
        }));
      }
      if (functionData.name === 'DATE_DIFFERENCE') {
        return params.options.map((option) => ({
          value: option,
          label: labelForDateDifference(option),
        }));
      }
      if (functionData.name === 'PERCENTAGE') {
        return params.options.map((option) => ({
          value: option,
          label: labelForPercentagePatterns(option),
        }));
      }
      return params.options.map((option) => ({ value: option, label: option }));
    }
  };

  descriptionToCurrencyDetails = (functionData, params, currency, displayType) => {
    const { methodType } = this.state;
    const currencyDisplay = currency[displayType]
      ? currency[displayType]
      : currency
      ? currency['symbol']
      : '$';
    if (methodType) {
      if (functionData.name === 'CURRENCY_FORMAT') {
        return params.options.map((option) => ({
          value: option,
          label:
            params.name === 'currency'
              ? labelForCurrency(option)
              : params.name === 'displayType'
              ? labelForCurrencyDisplay(option, currency)
              : params.name === 'maxFraction'
              ? labelForCurrencymaxFraction(option, currency)
              : labelForCurrencyPosition(option, currencyDisplay),
        }));
      }
    }
  };

  descriptionToUnixTypes = (functionData, params) => {
    const { methodType } = this.state;
    if (methodType) {
      if (functionData.name === 'FORMAT_DATE') {
        return params.options.map((option) => ({
          value: option,
          label: lableForUnixType(option),
        }));
      }
      return params.options.map((option) => ({ value: option, label: option }));
    }
  };

  descriptionToSeparator = (functionData, params) => {
    if (functionData.name === 'SPLIT_STRING') {
      return params.options.map((option) => ({
        value: option,
        label: labelForSeparator(option),
      }));
    }
  };

  getFormatOption = (functionData, params, currency, displayType) => {
    switch (params.name) {
      case 'formatType':
        return this.descriptionToFormatTypes(functionData, params, currency, displayType);
      case 'currency':
      case 'position':
      case 'displayType':
      case 'maxFraction':
        return this.descriptionToCurrencyDetails(functionData, params, currency, displayType);
      case 'unixType':
        return this.descriptionToUnixTypes(functionData, params);
      case 'separator':
        return this.descriptionToSeparator(functionData, params);
      case 'type':
        return params.options.sort().map((option) => ({
          value: option,
          label: option === 'JSON_FIELDS' ? 'JSON Fields' : snakeCaseToTitleCase(option),
        }));
      default:
        return params.options
          .sort()
          .map((option) => ({ value: option, label: snakeCaseToTitleCase(option) }));
    }
  };

  getFieldsForParams = (params, allowedTypes) => {
    const { collection, refCollectionItems } = this.props;
    const { refCollection, refField, methodType } = this.state;
    switch (params.name) {
      case 'datentime1':
      case 'datentime2':
        return [
          { value: 'CURRENT_DATE_TIME', label: 'Current Date & Time' },
          ...this.getAllAllowedFieldForSelect(allowedTypes, collection),
        ];
      case 'refField':
        const allowedTypesForRefField = ['COUNT', 'PERCENTAGE'].includes(methodType.value)
          ? OptionTypeFields
          : [];
        return this.getAllAllowedFieldForSelect(allowedTypesForRefField, refCollection);
      case 'match':
        if (refCollection) {
          const refCollectionField = refCollection.fields.find(
            (field) => field.fieldName === refField.value,
          );
          if (childDataField.includes(refCollectionField.type)) {
            return refCollectionItems.map((item) => ({
              value: item[refCollectionField.refCollection.collectionField],
              label: item[refCollectionField.refCollection.collectionField],
            }));
          } else if (refCollectionField.type === FieldTypes.static_option.id) {
            return refCollectionField.staticOptions.map((value) => ({ label: value, value }));
          }
        }
        return [];
      case 'type':
      case 'field':
        let allowedTypesForField = [];
        const urlParamMethod = CustomFunction.data.find(
          (method) => method.name === 'URL_PARAMETERS',
        );
        if (this.state.type) {
          const selectedType = this.state.type.value;
          const allowedTypesForURLParam = urlParamMethod.allowedTypes;
          if (selectedType === 'ALL_FIELDS') {
            allowedTypesForField = allowedTypesForURLParam.filter((type) =>
              textNumberField.includes(type),
            );
            return this.getAllAllowedFieldForSelect(allowedTypesForField, this.props.collection);
          } else {
            allowedTypesForField = allowedTypesForURLParam.filter((type) => type === 'json');
            return this.getAllAllowedFieldForSelect(allowedTypesForField, this.props.collection);
          }
        }
      default:
        return this.getAllAllowedFieldForSelect(allowedTypes, this.props.collection);
    }
  };

  tableParams = ['tableStyle', 'theadStyle', 'tbodyStyle', 'trStyle', 'tdStyle', 'thStyle'];

  createParmField = (
    values,
    functionData,
    params,
    setFieldValue,
    setFieldTouched,
    allowedTypes,
    secondary = false,
  ) => {
    if (params.external) {
      if (
        params.name === 'indexNum' &&
        (!this.state.index || this.state.index.value !== 'NTH_ITEM')
      )
        return '';
      const isTableParams = this.tableParams.includes(params.name);
      if (isTableParams && !this.state.tableStyleToggle) return '';
      const isEditor = functionData.name === 'CUSTOM_JAVASCRIPT_LOGIC';
      return (
        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12" key={params.name}>
          <div className="form-group bmd-form-group">
            <FormFieldWithLabel
              cta={false}
              label={params.label}
              icon={isTableParams ? 'text-placeholder' : 'text'}
              infoIcon={params.hint || false}
              infoDescription={params.hint}
            >
              {params.name === 'expression' ? (
                <>
                  {isEditor ? (
                    <>
                      {' '}
                      <AceEditor
                        id="customExpression"
                        mode={'javascript'}
                        theme="tomorrow"
                        value={values[params.name]}
                        name={params.name}
                        width="90%"
                        height={'30vh'}
                        fontSize={15}
                        wrapEnabled={true}
                        showPrintMargin={false}
                        onLoad={(editor) => this.setState({ editor })}
                        onChange={(e) => setFieldValue('expression', e)}
                        editorProps={{ $blockScrolling: true }}
                      />
                    </>
                  ) : (
                    <>
                      <Field
                        id="customExpression"
                        as="textarea"
                        rows={3}
                        name={params.name}
                        className="form-control"
                        data-lang="en"
                        placeholder={`${params.label}*`}
                      />
                    </>
                  )}
                  <span className="input-group-text align-items-end px-0">
                    {this.showAddFieldsModal(setFieldValue, isEditor)}
                    <button
                      type="button"
                      className="btn btn-theme-submit btn-xs btn-icon-only"
                      title="Add Fields"
                      onClick={this.toggleAddFieldsModal}
                    >
                      <i className="wb webconnect-plus" />
                    </button>
                  </span>
                </>
              ) : (
                <Field
                  type={params.type ? params.type : 'text'}
                  name={params.name}
                  className="form-control"
                  data-lang="en"
                  placeholder={`${params.label}*`}
                />
              )}
            </FormFieldWithLabel>
          </div>
          <div className="pl-0 ml-5 errors">
            <ErrorMessage name={params.name} />
          </div>
        </div>
      );
    } else {
      if (this.state.methodType.value === 'TABLE_FORMAT' && params.name === 'tableRefernceFields') {
        if (!this.state.subject) return '';
        return (
          <>
            <FieldsMapping
              tableRefernceFields={this.state.tableRefernceFields}
              params={params}
              collection={this.state.refCollection}
              handleChange={this.handleChange}
            />
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
              <div className="d-flex justify-content-end align-items-center">
                <span className="p-2" style={{ fontWeight: 'bold' }}>
                  Show Table Styles
                </span>
                <div className="mt-3">
                  <ToggleButton
                    name="tableStyleToggle"
                    onChange={() =>
                      this.setState({ tableStyleToggle: !this.state.tableStyleToggle })
                    }
                    isChecked={this.state.tableStyleToggle}
                  />
                </div>
              </div>
            </div>
          </>
        );
      }
      let currency = '';
      let displayType = '';
      if (this.state.currency && this.state.currency.value) currency = this.state.currency.value;
      if (currency.code === 'NONE' && ['displayType', 'position'].includes(params.name)) return '';
      if (this.state.displayType && this.state.displayType.value)
        displayType = this.state.displayType.value;
      if (params.name === 'unixType' && !secondary) return '';
      if (
        params.name === 'condition' &&
        (!this.state.subject ||
          (this.state.subject && OptionTypeFields.includes(this.state.subject.type)))
      )
        return '';
      if (params.name === 'condition' && this.state.subject.type === FieldTypes.reference.id) {
        params.options = !params.options.includes('NONE')
          ? ['NONE', ...params.options]
          : params.options;
      }
      if (
        params.name === 'refField' &&
        ((['COUNT', 'PERCENTAGE'].includes(this.state.methodType.value) &&
          (!this.state.condition || this.state.condition.value === 'NONE')) ||
          (['FIND_RECORD'].includes(this.state.methodType.value) && !this.state.subject))
      )
        return '';
      if (params.name === 'match' && !this.state.refField) return '';
      let formatOptions = params.options
        ? this.getFormatOption(functionData, params, currency, displayType)
        : [];

      let fields = this.getFieldsForParams(params, allowedTypes);
      return (
        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12" key={params.name}>
          <div className="form-group bmd-form-group">
            <FormFieldWithLabel
              cta={false}
              label={params.label}
              icon="select"
              infoIcon={params.hint || false}
              infoDescription={params.hint}
            >
              <CustomSelect
                name={params.name}
                isMulti={params.minArgCount > 1}
                options={formatOptions && formatOptions.length > 0 ? formatOptions : fields}
                onChange={setFieldValue}
                onBlur={setFieldTouched}
                placeholder={params.placeholder ? params.placeholder : 'Select'}
                onChangeValue={this.handleChange}
              />
            </FormFieldWithLabel>
            <div className="pl-5">
              {params.hint ? <small className="field-detail">{params.hint}</small> : ''}
            </div>
          </div>
          <div className="pl-0 ml-5 errors">
            <ErrorMessage name={params.name} />
          </div>
        </div>
      );
    }
  };

  clearForm = () => {
    customFunctionSchema.functionName = '';
    customFunctionSchema.methodType = '';
    customFunctionSchema.formatType = '';
    customFunctionSchema.numbers = '';
    customFunctionSchema.numbers1 = '';
    customFunctionSchema.numbers2 = '';
    customFunctionSchema.subject = '';
    customFunctionSchema.restToLower = '';
    this.setState({ methodType: null, condition: null, refField: null, match: null, index: null });
  };

  renderParameters = (values, setFieldValue, setFieldTouched) => {
    const { methodType } = this.state;
    const paramField = [];
    if (methodType) {
      const functionData = CustomFunction.data.find((param) => {
        return param.name === methodType.value;
      });

      functionData.args.forEach((param) => {
        paramField.push(
          this.createParmField(
            values,
            functionData,
            param,
            setFieldValue,
            setFieldTouched,
            functionData.allowedTypes,
          ),
        );
      });
    }
    return paramField;
  };

  renderUnixType = (values, setFieldValue, setFieldTouched) => {
    const { methodType, datentime } = this.state;
    const {
      collection: { fields },
    } = this.props;
    if (methodType && methodType.value === 'FORMAT_DATE' && datentime) {
      if (fields.length > 0) {
        const field = fields.find((field) => field.fieldName === datentime.value);
        if (field.type === 'unix_timestamp') {
          const paramField = [];
          const functionData = CustomFunction.data.find((param) => {
            return param.name === methodType.value;
          });
          functionData.args.forEach((param) => {
            if (param.name === 'unixType') {
              paramField.push(
                this.createParmField(
                  values,
                  functionData,
                  param,
                  setFieldValue,
                  setFieldTouched,
                  functionData.allowedTypes,
                  true,
                ),
              );
            }
          });
          return paramField;
        }
      }
    }
  };

  getValuesForCount = (values) => {
    const { refCollection, refField, subject, condition } = this.state;
    if (
      ['COUNT', 'FIND_RECORD', 'PERCENTAGE'].includes(this.state.methodType.value) &&
      !OptionTypeFields.includes(subject.type)
    ) {
      if (condition && condition.value !== 'NONE') {
        const { type: refFieldType } = refCollection.fields.find(
          (field) => field.fieldName === refField.value,
        );
        [{ refFieldType }].forEach((value) => {
          const key = Object.keys(value)[0];
          values[key] = { value: value[key], label: value[key] };
        });
      }
    }
    this.setState({ subject: null, refField: null, condition: null, match: null });
    return values;
  };

  getValuesForTableFormat = (values) => {
    const { tableRefernceFields } = this.state;
    if (this.state.methodType.value === 'TABLE_FORMAT') {
      const newMapping = [];
      tableRefernceFields.forEach((row) => {
        if (row.value && !['', undefined].includes(row.value)) {
          newMapping.push({ field: row.key, header: row.value });
        }
      });
      values = {
        ...values,
        tableRefernceFields: [{ id: 1, key: 'fieldMapping', value: newMapping }],
      };
    }
    this.setState({ subject: null, tableRefernceFields: [{ id: 0, key: '', value: '' }] });
    return values;
  };

  handleSubmit = (values) => {
    values = this.getValuesForCount(values);
    values = this.getValuesForTableFormat(values);
    const createUtilityData = parseUtilityFunctionFormData(values);
    const { projectId, collection, actions, version } = this.props;
    actions.addUtilityFunctionToCollection({
      projectId,
      version,
      collectionUuid: collection.uuid,
      data: createUtilityData,
    });
  };

  copyToClipboard = () => {
    this.setState({ copied: true });
    this.toggleAddFieldsModal();
    toast.success('Copied to clipboard');
    setTimeout(() => {
      this.setState({ copied: false });
    }, 2000);
  };

  insertTextToParamInput = (textToInsert, setFieldValue, isEditor = false) => {
    if (textToInsert) {
      let newText = '';
      if (isEditor) {
        const { editor } = this.state;
        if (editor) {
          const cursorPosition = editor.getCursorPosition();
          editor.session.insert(cursorPosition, textToInsert);
          newText = editor.getValue();
        }
      } else {
        let customExpressionElem = document.getElementById('customExpression');
        let start = customExpressionElem.selectionStart;
        let finish = customExpressionElem.selectionEnd;
        let allText = customExpressionElem.value;
        let sel = allText.substring(start, finish);
        if (sel) {
          newText = allText.replace(sel, textToInsert);
        } else {
          newText = allText + textToInsert;
        }
      }
      setFieldValue('expression', newText);
      this.toggleAddFieldsModal();
      toast.success('Text Inserted');
    }
  };

  showAddFieldsModal = (setFieldValue, isEditor = false) => {
    const { collection, collections, projectDetail } = this.props;

    return this.state.addFieldsModal ? (
      <RestAPICollectionFieldsModal
        selectedCollection={collection}
        collections={collections}
        copyToClipboard={this.copyToClipboard}
        insertTextToEditor={(textToInsert) =>
          this.insertTextToParamInput(textToInsert, setFieldValue, isEditor)
        }
        toggleFields={this.state.addFieldsModal}
        toggleFieldsModal={this.toggleAddFieldsModal}
        projectDetail={projectDetail}
        hide={[
          'derivedFields',
          'collectionConstants',
          'projectConstants',
          'userDerivedFields',
          'authToken',
          'tenantFields',
          'userSettingFields',
        ]}
      />
    ) : (
      ''
    );
  };

  render() {
    const showDerivedFieldCreateLoader = this.props.showDerivedFieldCreateLoader;
    const { collection } = this.props;
    const fieldsToShow = collection.fields.filter((field) => {
      return !systemAndRefField.includes(field.type);
    });
    const fieldObj = {};
    fieldsToShow.forEach((field) => {
      fieldObj[field.fieldTitle.en] = field.fieldName;
    });
    return (
      <>
        <Modal
          isOpen={this.state.toggleShowFieldsModal}
          toggle={() => {
            this.setState({ toggleShowFieldsModal: !this.state.toggleShowFieldsModal });
          }}
          backdrop="static"
          style={{ maxWidth: '800px', marginTop: '70px' }}
        >
          <ModalHeader
            toggle={() => {
              this.setState({ toggleShowFieldsModal: !this.state.toggleShowFieldsModal });
            }}
            className="border-bottom"
          >
            <strong>Fields</strong>
          </ModalHeader>
          <ModalBody>
            <pre className="item-detail-data">{JSON.stringify(fieldObj, null, 2)}</pre>
          </ModalBody>
        </Modal>
        <Formik
          initialValues={this.state.formSchema}
          validationSchema={prepareValidationForDerivedField()}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            this.handleSubmit(values);
            setSubmitting(false);
            this.clearForm();
            resetForm();
          }}
        >
          {({ values, isSubmitting, setFieldValue, setFieldTouched, resetForm, errors }) => {
            return (
              <Form className="form-horizontal">
                <div className="row mx-auto">
                  <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                    <div className="form-group bmd-form-group">
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <i className={`wb ${iconForField('text')}`}></i>
                            <span className="required"> *</span>
                          </span>
                        </div>
                        <Field
                          type="text"
                          name="functionName"
                          className="form-control"
                          data-lang="en"
                          placeholder="Name a Derived Field"
                        />

                        <ErrorMessage name="functionName">
                          {(msg) => <p className="text-error">{msg}</p>}
                        </ErrorMessage>

                        {/* */}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                    <div className="form-group bmd-form-group">
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <i className={`wb ${iconForField('select')}`}></i>
                            <span className="required"> *</span>
                          </span>
                        </div>
                        <CustomSelect
                          name="methodType"
                          isMulti={false}
                          value={this.state.methodType}
                          options={this.state.methodTypes}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          onChangeValue={this.handleChange}
                          placeholder="Select Method Type"
                        />

                        <ErrorMessage name="methodType">
                          {(msg) => <p className="text-error">{msg}</p>}
                        </ErrorMessage>
                        <div className="input-group-append">
                          <span
                            className="input-group-text"
                            data-tip="Select Method Type"
                            title="Select Method Type"
                          >
                            <i className={`wb ${drapcodeIcon('description')}`}></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mx-auto">
                  {this.renderParameters(values, setFieldValue, setFieldTouched)}
                </div>
                <div className="row mx-auto">
                  {this.renderUnixType(values, setFieldValue, setFieldTouched)}
                </div>
                <div className="col-md-12 col-lg-12 text-right">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-md"
                    onClick={() =>
                      this.setState({ toggleShowFieldsModal: !this.state.toggleShowFieldsModal })
                    }
                  >
                    <i className="wb webconnect-eye" />
                    &nbsp;<span>Show Fields</span>
                  </button>
                  &nbsp;
                  <button
                    type="button"
                    className="btn btn-defaul btn-md"
                    onClick={() => {
                      resetForm();
                      this.clearForm();
                    }}
                  >
                    <span>
                      <i className="wb webconnect-eraser"></i>&nbsp;Clear
                    </span>
                  </button>
                  &nbsp;
                  <button
                    type="submit"
                    className="btn btn-theme-submit btn-md"
                    disabled={isSubmitting || showDerivedFieldCreateLoader ? 'disabled' : ''}
                  >
                    <i className="wb webconnect-plus"></i>&nbsp;Create&nbsp;
                    <CustomLoader loading={showDerivedFieldCreateLoader} />
                  </button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </>
    );
  }
}
